<!-- 配件调拨历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">提交时间</div>
                <div class="">
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" style="height: 32px">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch" style="height: 32px">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <el-table-column width="180px" prop="OrderCode" label="调拨单号" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="WarehouseName" :label="OrderType=='1'?'调出仓库':'调入仓库'" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="GoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Origin" label="产地"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Price" v-if="IsShowCost" label="成本价"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Price" v-if="!IsShowCost" label="售价"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Creator" label="创建人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="ConfirmTime" label="提交时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        GoodsId: {
            type: String
        },
        WarehouseName: {
            type: String
        },
        IsShowCost: {
            type: Boolean//是否显示成本价格
        },
        OrderType: {
            type: String//0调入，1调出
        },
        SId: {
            type: String//仓库
        },        
    },
    components: {  },
    data() {
        return {
            loading: false,
            selLoading: false,
            searchData: {
                OrderType:this.OrderType,
                GoodsId: this.GoodsId,
                SId:this.SId,
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            },
            tableData: [],
            tableDataLength: 0,
            dateTimes: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }            
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },        
        resetSearch() {
            this.searchData = {
                OrderType:this.OrderType,
                GoodsId: this.GoodsId,
                SId:this.SId,
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes =[];
        },
        getTableData() {
            let that=this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetTransHistoriesList',
                    data: that.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    data.forEach((e, index) => {
                        e.WarehouseName=that.WarehouseName;
                    })
                    that.tableData =data;
                    that.tableDataLength = res.count;
      
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;
        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }
    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}
</style>
